import { UITag } from "common/components";
import * as Styled from "domains/moderate/sources/components/SourceDetailSection/SourceDetailSection.styled";

type TagFormAttributeProps = {
  label: string;
  noValuePlaceholder: string;
  value?: string;
};

export const TagFormAttribute = ({ label, noValuePlaceholder, value }: TagFormAttributeProps) => (
  <>
    <Styled.SourceAttributeLabel>{label}</Styled.SourceAttributeLabel>
    {value ? <UITag>{value}</UITag> : <Styled.SourceAttributeValue>{noValuePlaceholder}</Styled.SourceAttributeValue>}
  </>
);
